import withPageTitle from "../../../routes/containers/withPageTitle"
import PrivacyPolicy from "../components/PrivacyPolicy"

export default withPageTitle("Privacy Policy")(PrivacyPolicy)
